export default "__VITE_ASSET__B2vonq6Z__"